import { Dispatch, SetStateAction, useContext, useEffect } from "react";
import { Follow } from "./Follow";
import { UserContext, iUserFollower } from "../../../../../providers/UserContext";
import { FollowCard } from "./FollowCard";


interface iFollowing {
    setShowFollowing: Dispatch<SetStateAction<boolean>>;
    userPage: iUserFollower | null
}


export const Following = ({ setShowFollowing, userPage }: iFollowing) => {

    const { following, user, loadFollowers, loadFollowing } = useContext(UserContext)

    useEffect(() => {
        const loadFollowFollowing = async () => {
            try {
                // setLoading(true);
                if (userPage) {
                    loadFollowers(userPage.id);
                    loadFollowing(userPage.id);
                }
            } catch (error) {
                console.log(error);
            }
        };

        if (user) {
            loadFollowFollowing();
        }
    }, [user]);


    return (
        <Follow setShowFollow={setShowFollowing} title="Seguindo">
            {userPage?.Following.raw.map((wer: any, i: any) => {
                return (
                    <FollowCard wer={wer} userId={userPage.id} key={i} />
                )
            })}
        </Follow>)
}